import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiFilter, FiCheckCircle } from 'react-icons/fi';

const Sidebar = ({ feeds, activeFilter, onFilterChange }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5 sticky top-28">
      <div className="flex items-center space-x-2 mb-4 pb-4 border-b border-gray-100">
        <SafeIcon icon={FiFilter} className="text-black" />
        <h2 className="font-bold text-gray-900 uppercase text-sm tracking-wider">Filter Sources</h2>
      </div>
      
      <div className="space-y-1 max-h-[calc(100vh-250px)] overflow-y-auto pr-2 custom-scrollbar">
        <button
          onClick={() => onFilterChange('All')}
          className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-sm transition-all ${
            activeFilter === 'All'
              ? 'bg-black text-white font-bold'
              : 'text-gray-600 hover:bg-gray-50 hover:text-black'
          }`}
        >
          <span>All Sources</span>
          {activeFilter === 'All' && <SafeIcon icon={FiCheckCircle} className="text-[#FF0000]" />}
        </button>

        {feeds.map((feed) => (
          <button
            key={feed.name}
            onClick={() => onFilterChange(feed.name)}
            className={`w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-sm transition-all ${
              activeFilter === feed.name
                ? 'bg-black text-white font-bold'
                : 'text-gray-600 hover:bg-gray-50 hover:text-black'
            }`}
          >
            <span className="truncate pr-2 text-left">{feed.name}</span>
            {activeFilter === feed.name && <SafeIcon icon={FiCheckCircle} className="text-[#FF0000] flex-shrink-0" />}
          </button>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;